import HeaderV2 from "./HeaderV2";
import HeroSectionV2 from "./HeroSectionV2";
import TrustSectionV2 from "./TrustSectionV2";
import AboutSectionV2 from "./AboutSectionV2";
import ServicesSectionV2 from "./ServicesSectionV2";
import MethodologySectionV2 from "./MethodologySectionV2";
import ResultsSectionV2 from "./ResultsSectionV2";
import InsightsSectionV2 from "./InsightsSectionV2";
import ContactSectionV2 from "./ContactSectionV2";
import FooterV2 from "./FooterV2";

const HomeV2 = () => {
  return (
    <div className="bg-white" data-testid="app-container-v2">
      <HeaderV2 />
      <main>
        <HeroSectionV2 />
        <TrustSectionV2 />
        <AboutSectionV2 />
        <ServicesSectionV2 />
        <MethodologySectionV2 />
        <ResultsSectionV2 />
        <InsightsSectionV2 />
        <ContactSectionV2 />
      </main>
      <FooterV2 />
    </div>
  );
};

export default HomeV2;
